export default __webpack_public_path__ + "static/media/eye_close.de73a5d2.svg";